import { render, staticRenderFns } from "./AppFast.vue?vue&type=template&id=90d294b6&lang=pug&"
import script from "./AppFast.vue?vue&type=script&lang=ts&"
export * from "./AppFast.vue?vue&type=script&lang=ts&"
import style0 from "./AppFast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports